import { T } from 'gt-react';
import { Label } from 'src/components/ui/label';
import { Button } from 'src/components/ui/button';
import { PlusIcon } from '@phosphor-icons/react';
import { IdentifyPartyOthersToggles } from './IdentifyPartyOthersToggles';
import { IdentifyPartyRouteList } from './IdentifyPartyRouteList';
import {
  appendEmptyPartyRoute,
  type IdentifyPartyRoutingSectionProps,
} from './identifyPartyFormConfig';

export function IdentifyPartyRoutingSection(
  props: IdentifyPartyRoutingSectionProps,
) {
  return (
    <section className="space-y-3">
      <div>
        <Label className="text-sm">
          <T>Routing</T>
        </Label>
        <p className="text-[11px] text-muted-foreground mt-0.5">
          {props.routingHelp}
        </p>
      </div>

      <IdentifyPartyRouteList
        routes={props.routes}
        siblingSets={props.siblingSets}
        entityCounts={props.entityCounts}
        reserved={props.reserved}
        slugFallback={props.slugFallback}
        duplicateMessage={props.duplicateMessage}
        noEntitySelectedLabel={props.noEntitySelectedLabel}
        emptyRoutesHelp={props.emptyRoutesHelp}
        renderPicker={props.renderPicker}
        EntityName={props.EntityName}
        onRoutesChange={props.onRoutesChange}
      />

      <Button
        variant="outline"
        size="sm"
        className="w-full"
        onClick={() =>
          props.onRoutesChange(appendEmptyPartyRoute(props.routes))
        }
      >
        <PlusIcon className="w-3 h-3 mr-1.5" />
        {props.addRouteLabel}
      </Button>

      <IdentifyPartyOthersToggles
        othersHelp={props.othersHelp}
        othersNoMatchHelp={props.othersNoMatchHelp}
        enableOthers={props.enableOthers}
        othersEmitNullWhenNoMatch={props.othersEmitNullWhenNoMatch}
        onEnableOthersChange={props.onEnableOthersChange}
        onOthersEmitNullWhenNoMatchChange={
          props.onOthersEmitNullWhenNoMatchChange
        }
      />

      <div className="rounded-md bg-muted/50 p-3 text-xs text-muted-foreground space-y-1.5">
        <p className="font-medium text-foreground">
          <T>How outputs work</T>
        </p>
        {props.howOutputs}
      </div>
    </section>
  );
}
